import axios from 'axios';
import autoComplete from '@tarekraafat/autocomplete.js'

document.addEventListener('turbolinks:load', () => {
  // autoCompletejs.searchEngine = "strict";
  var el = document.getElementById('autoComplete')
  // console.log(el)
  if(el){

    document.querySelector("#autoComplete").addEventListener("#autoComplete", event => {
      // console.log(event);
    });// autoComplete.js on typing event emitter
    
    new autoComplete({
      data: { // Data src [Array, Function, Async] | (REQUIRED)
        src: async () => { // Loading placeholder text
          document
            .querySelector("#autoComplete")
            .setAttribute("placeholder", "Loading..."); // Fetch External Data Source
          const url = process.env.ROOT_DIR + "customers/get_customers";
          axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';
          // console.log(url)
          const queries = {
            team_id: gon.team_id
          }
          const source = await axios.get(url,
            {params: queries}
            ).then((response)=>{return response.data})
          // console.log(source.customers)
          document
            .querySelector("#autoComplete")
            .setAttribute("placeholder", "取引先名称");
          return source.customers;
        },
        key: ["name"],
        cache: false
      },
      sort: (a, b) => {
        if (a.match < b.match) return -1;
        if (a.match > b.match) return 1;
        return 0;
      },
      placeHolder: gon.customer_name,
      selector: "#autoComplete",
      threshold: 0,
      debounce: 0,
      searchEngine: "strict",
      highlight: true,
      maxResults: 5,
      resultsList: {
        render: true,
        container: source => {
          source.setAttribute("id", "autoComplete_list");
          source.setAttribute("class", "autoComplete_list uk-box-shadow-large");
        },
        destination: document.querySelector("#autoComplete"),
        position: "afterend",
        element: "ul"
      },
      resultItem: {
        content: (data, source) => {
          source.innerHTML = data.match;
        },
        element: "li"
      },
      noResults: () => {
        const result = document.createElement("li");
        result.setAttribute("class", "no_result");
        result.setAttribute("tabindex", "1");
        result.innerHTML = "新規登録になります";
        document.querySelector("#autoComplete_list").appendChild(result);
      },
      onSelection: feedback => {
        const selection = feedback.selection.value;
        // Render selected choice to selection div
        document.querySelector(".selection").innerHTML = selection.name;
        // Clear Input
        document.querySelector("#autoComplete").value = selection.name;
        // Change placeholder with the selected value
        document
          .querySelector("#autoComplete")
          .setAttribute("placeholder", selection.name);
        // Concole log autoComplete data feedback
        console.log(feedback);
      }
    });

    // // Toggle Search Engine Type/Mode
    // document.querySelector(".toggeler").addEventListener("click", function() {
    //   // Holdes the toggle buttin alignment
    //   const toggele = document.querySelector(".toggele").style.justifyContent;

    //   // if (toggele === "flex-start" || toggele === "") {
    //   //   // Set Search Engine mode to Loose
    //   //   document.querySelector(".toggele").style.justifyContent = "flex-end";
    //   //   document.querySelector(".toggeler").innerHTML = "Loose";
    //   //   autoCompletejs.searchEngine = "loose";
    //   // } else {
    //     // Set Search Engine mode to Strict
    //     document.querySelector(".toggele").style.justifyContent = "flex-start";
    //     document.querySelector(".toggeler").innerHTML = "Strict";
    //     autoCompletejs.searchEngine = "strict";
    //   // }
    // });


    // Toggle results list and other elements
    const action = function(action) {
      // const mode = document.querySelector(".mode");
      const selection = document.querySelector(".selection");

      if (action === "dim") {
        // mode.style.opacity = 1;
        selection.style.opacity = 1;
      } else {
        // mode.style.opacity = 0.2;
        selection.style.opacity = 0.1;
      }
    };


    // Toggle event for search input
    // showing & hidding results list onfocus / blur
    ["focus", "blur"].forEach(function(eventType) {
      const resultsList = document.querySelector("#autoComplete_list");

      document.querySelector("#autoComplete").addEventListener(eventType, function() {
        // Hide results list & show other elemennts
        if (eventType === "blur") {
          action("dim");
          resultsList.style.display = "none";
        } else if (eventType === "focus") {
          // Show results list & hide other elemennts
          action("light");
          resultsList.style.display = "block";
        }
      });
    });
  }
})

  // const autocomplete = require('autocomplete.js');  
  
  // const datalist = () => {
  //     const url = `/customers/get_customers`;
  //     axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';
  //     return axios.get(url).then((res)=>{
  //       console.log(res)
  //       const items = res.data;
  //       console.log(items)
  //       return items;
  //     })
  // }


  // function newHitsSource(index, params) {
  //   return function doSearch(query, cb) {
  //     index
  //       .search(query, params)
  //       .then(function(res) {
  //         cb(res.hits, res);
  //       })
  //       .catch(function(err) {
  //         console.error(err);
  //         cb([]);
  //       });
  //   };
  // }
  
  // var data = [
  //   'accepts',
  //   'action_name',
  //   'add',
  //   'add_column',
  //   'add_index',
  //   'add_timestamps',
  //   'after_create',
  //   'after_destroy',
  //   'after_filter',
  //   'all']
  
  //   $('#store_search').autocomplete({
  //     source: data,
  //     autoFocus: true,
  //     delay: 500,
  //     minLength: 2
  //   });

  // autocomplete('#store_search', { hint: false }, [
  //   {
  //     // source: newHitsSource(datalist, { hitsPerPage: 5 }),
  //     source: datalist.customers,
  //     displayKey: 'name',
  //     // templates: {
  //     //   suggestion: function(suggestion) {
  //     //     console.log(suggestion._highlightResult)
  //     //     return `${suggestion._highlightResult.name}`
  //     //   }
  //     // }
  //   }
  // ]).on('autocomplete:selected', function(event, suggestion, dataset, context) {
  //   console.log(datalist)
  //   if (context.selectionMethod === 'click') {
  //     // window.location.assign(`/customers/${suggestion.objectID}`);
  //     return;
  //   }
  // });



// })

document.addEventListener('turbolinks:load', () => {
  // autoCompletejs.searchEngine = "strict";
  var sale_el = document.getElementById('sale_autoComplete')
  // console.log(sale_el);
  if(sale_el){
    
    document.querySelector("#sale_autoComplete").addEventListener("#sale_autoComplete", event => {
      // console.log(event);
    });// autoComplete.js on typing event emitter
    
    new autoComplete({
      data: { // Data src [Array, Function, Async] | (REQUIRED)
        src: async () => { // Loading placeholder text
          document
            .querySelector("#sale_autoComplete")
            .setAttribute("placeholder", "Loading..."); // Fetch External Data Source
          const url = process.env.ROOT_DIR + "customers/get_customers";
          axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';
          // console.log(url)
          const queries = {
            team_id: gon.team_id
          }
          const source = await axios.get(url,
            {params: queries}
            ).then((response)=>{return response.data})
          // console.log(source.customers)
          document
            .querySelector("#sale_autoComplete")
            .setAttribute("placeholder", "取引先名称");
          return source.customers;
        },
        key: ["name"],
        cache: false
      },
      sort: (a, b) => {
        if (a.match < b.match) return -1;
        if (a.match > b.match) return 1;
        return 0;
      },
      placeHolder: gon.customer_name,
      selector: "#sale_autoComplete",
      threshold: 0,
      debounce: 0,
      searchEngine: "strict",
      highlight: true,
      maxResults: 5,
      resultsList: {
        render: true,
        container: source => {
          source.setAttribute("id", "sale_autoComplete_list");
          source.setAttribute("class", "sale_autoComplete_list uk-box-shadow-large");
        },
        destination: document.querySelector("#sale_autoComplete"),
        position: "afterend",
        element: "ul"
      },
      resultItem: {
        content: (data, source) => {
          source.innerHTML = data.match;
        },
        element: "li"
      },
      noResults: () => {
        const result = document.createElement("li");
        result.setAttribute("class", "no_result");
        result.setAttribute("tabindex", "1");
        result.innerHTML = "新規登録になります";
        document.querySelector("#sale_autoComplete_list").appendChild(result);
      },
      onSelection: feedback => {
        const selection = feedback.selection.value;
        // Render selected choice to selection div
        document.querySelector(".selection").innerHTML = selection.name;
        // Clear Input
        document.querySelector("#sale_autoComplete").value = selection.name;
        // Change placeholder with the selected value
        document
          .querySelector("#sale_autoComplete")
          .setAttribute("placeholder", selection.name);
        // Concole log autoComplete data feedback
        console.log(feedback);
      }
    });

    // // Toggle Search Engine Type/Mode
    // document.querySelector(".toggeler").addEventListener("click", function() {
    //   // Holdes the toggle buttin alignment
    //   const toggele = document.querySelector(".toggele").style.justifyContent;

    //   // if (toggele === "flex-start" || toggele === "") {
    //   //   // Set Search Engine mode to Loose
    //   //   document.querySelector(".toggele").style.justifyContent = "flex-end";
    //   //   document.querySelector(".toggeler").innerHTML = "Loose";
    //   //   autoCompletejs.searchEngine = "loose";
    //   // } else {
    //     // Set Search Engine mode to Strict
    //     document.querySelector(".toggele").style.justifyContent = "flex-start";
    //     document.querySelector(".toggeler").innerHTML = "Strict";
    //     autoCompletejs.searchEngine = "strict";
    //   // }
    // });


    // Toggle results list and other elements
    const action = function(action) {
      // const mode = document.querySelector(".mode");
      const selection = document.querySelector(".selection");

      if (action === "dim") {
        // mode.style.opacity = 1;
        selection.style.opacity = 1;
      } else {
        // mode.style.opacity = 0.2;
        selection.style.opacity = 0.1;
      }
    };


    // Toggle event for search input
    // showing & hidding results list onfocus / blur
    ["focus", "blur"].forEach(function(eventType) {
      const resultsList = document.querySelector("#sale_autoComplete_list");

      document.querySelector("#sale_autoComplete").addEventListener(eventType, function() {
        // Hide results list & show other elemennts
        if (eventType === "blur") {
          action("dim");
          resultsList.style.display = "none";
        } else if (eventType === "focus") {
          // Show results list & hide other elemennts
          action("light");
          resultsList.style.display = "block";
        }
      });
    });
  }
})
